module.exports = __webpack_public_path__ + "assets/4d17e365064d60e2378dbea5e8491145.png";